var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19365_371259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 15.5845C47.9999 13.9277 46.6567 12.5845 45 12.5845H39.879C41.2042 11.2773 42.0525 9.56355 42.0525 7.453C42.0525 4.85425 40.56 2.03125 36.3705 2.03125C30.858 2.03125 26.253 7.90075 24.0892 11.191C21.924 7.9015 17.178 2.032 11.6662 2.032C7.47675 2.032 5.98425 4.855 5.98425 7.45375C5.98425 9.5635 6.85575 11.278 8.208 12.5852H3C1.34325 12.5852 0 13.9285 0 15.5852V24.565H3.02625V44.0913C3.02625 45.748 4.36945 47.0913 6.02625 47.0913H42.0112C43.6679 47.0913 45.0112 45.748 45.0112 44.0913V24.5643H48V15.5845H47.9999ZM36.3705 5.032C38.2252 5.032 39.0525 5.8113 39.0525 7.4538C39.0525 10.786 35.3332 12.5838 31.8352 12.5838H26.757C28.8885 9.418 32.64 5.032 36.3705 5.032ZM11.6662 5.03205C15.3975 5.03205 19.2907 9.41805 21.4222 12.583H16.3424C12.8444 12.583 8.98416 10.7388 8.98416 7.40655C8.98416 5.7648 9.81141 5.03205 11.6662 5.03205ZM44.9999 21.5642H25.4999V15.5845H44.9999V21.5642ZM2.99995 15.5845H22.5V21.5642H2.99995V15.5845ZM6.0262 24.5643H22.5V44.0905H6.0262V24.5643ZM42.012 44.0905H25.4999V24.5643H42.012V44.0905Z",
    fill: "#ABE138"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19365_371259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/gift-box.f31245bf05157e24814a4c4bc8bf19df.svg";
export { ForwardRef as ReactComponent };